'use strict';

function SearchBar() {
	return {
		restrict: 'E',
		scope: { search: '=' },
		replace: true,
		templateUrl: 'views/components/searchBar.html'
	}
}
export default SearchBar


// WEBPACK FOOTER //
// ./src/app/scripts/directives/searchBarDirective.js